export default __webpack_public_path__ + "static/media/twos.c96d07e5.png";